import { pingParams } from './format';
// import recordHttpLog from './recordHttpLog';
import { getSession } from '../index';
var errReportNum = 0;

// 发送请求
const postError = (pa) => {
  errReportNum++;
  // 避免进入报错死循环
  console.log('在这次打开页面，已经进行', errReportNum, '次报错啦');
  if (errReportNum > 30) return;

  let user = getSession('user') || null;
  let url = window.location.href;
  // let hash = window.location.pathname + window.location.hash;
  let params = {
    // user: user ? JSON.stringify(user)  : '', // 用户信息
    user: user ? user.name : '', // 用户信息
    userAgent: window.navigator.userAgent, // 浏览器信息
    menuKey: getSession('menuKey') || '', // 当前模块
    locationHref: url, // 当前地址
    brand: getSession('brand') || '', // 当前品牌
  };
  let paramsStr = pingParams(Object.assign(params, pa));
  // GET 请求上报
  // let baseUrl = `http://10.16.85.47:1090/cmms-big-web/error-log/${process.env.env_config}?`;
  // let baseUrl = `http://localhost:1090/cmms-big-web/error-log/${process.env.env_config}?`;
  let baseUrl = `http://cmms2.midea.com/cmms-big-web/error-log/${process.env.env_config}?`;
  let src = baseUrl + paramsStr;
  const img = new Image();
  img.src = src;
};

export default postError;
